import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, styled } from "@mui/material";

const JSONView = styled("pre")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#343434" : "white",
  borderRadius: theme.spacing(1.5),
  padding: theme.spacing(1.5),
  fontSize: theme.typography.body2.fontSize,
  textWrap: "wrap",
}));

export const AnswerDebugDetail = ({ debugValue }: { debugValue: any }) => {
  return (
    <Box m={2} border={"1px solid #e0e0e0"}>
      <Accordion
        elevation={0}
        slotProps={{
          transition: {
            timeout: 0, // prevents long animation when large accordion is collapsed
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>Query Detail</AccordionSummary>
        <AccordionDetails>
          <JSONView>{JSON.stringify(debugValue, null, 2)}</JSONView>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
